import lodashMerge from 'lodash/merge';

const DEFAULT_VERBOSITY = 2;

const DEFAULT_OPTIONS = {
	verbosity: null,
	parent: null,
	prefix: ''
};

const SEVERITY_TAGS = {
	'1': 'ERROR',
	'2': 'WARNING',
	'3': 'INFO',
	'4': 'VERBOSE'
};

const SEVERITY_FNS = {
	'1': 'error',
	'2': 'warn',
	'3': 'log',
	'4': 'info',
};

function Logger(options = DEFAULT_OPTIONS) {
	const thisLogger = this;

	if (typeof options === 'number') {
		options = {
			verbosity: options
		};
	}

	options = lodashMerge({}, DEFAULT_OPTIONS, options);

	let _verbosity = options.verbosity;

	Object.assign(thisLogger, /** @lends Logger.prototype */ {
		children: {},
		parent: options.parent,

		getVerbosity,
		setVerbosity,

		error: doLog.bind(thisLogger, 1),
		warn: doLog.bind(thisLogger, 2),
		info: doLog.bind(thisLogger, 3),
		verbose: doLog.bind(thisLogger, 4),

		child
	});

	function getVerbosity() {
		if (_verbosity !== null) {
			return _verbosity;
		}
		if (options.parent) {
			return options.parent.getVerbosity();
		}
		return DEFAULT_VERBOSITY;
	}

	function setVerbosity(newVerbosity) {
		_verbosity = newVerbosity;
	}

	function doLog(severity) {
		if (severity > getVerbosity()) {
			return;
		}

		const severityTag = SEVERITY_TAGS[severity] || 'UNKNOWN';
		const fn = SEVERITY_FNS[severity];

		let out = ['[' + severityTag + ']'];
		if (options.prefix) {
			out.push('[' + options.prefix + ']');
		}
		for (let i = 1; i < arguments.length; i++) {
			out.push(arguments[i]);
		}
		console[fn].apply(console, out); // eslint-disable-line no-console
	}

	/**
	 * @param childName
	 * @return {Logger}
	 */
	function child(childName) {
		if (this.children[childName]) {
			return this.children[childName];
		}

		const childLogger = new Logger({
			prefix: options.prefix
				? `${options.prefix} > ${childName}`
				: childName,
			parent: thisLogger,
			verbosity: null
		});

		thisLogger.children[childName] = childLogger;

		return childLogger;
	}
}

Logger.NULL = new Logger(0);

// *********************************************************************************************************************

export default Logger;
